import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4002a9dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "content-main-wrap",
  id: "content-main-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"head\" data-v-4002a9dc><img src=\"https://static.knowledge.xag.cn/img/jijia2024/header-1212.png\" alt=\"\" data-v-4002a9dc></div><div class=\"linear-bg\" data-v-4002a9dc><div class=\"feature-wrap common-wrap\" data-v-4002a9dc><picture data-v-4002a9dc><source srcset=\"\n              https://static.knowledge.xag.cn/img/jijia2026/part1-1113.png?imageMogr2/format/webp\n            \" type=\"image/webp\" data-v-4002a9dc><source srcset=\"https://static.knowledge.xag.cn/img/jijia2026/part1-1113.png\" type=\"image/png\" data-v-4002a9dc><img src=\"https://static.knowledge.xag.cn/img/jijia2026/part1-1113.png\" alt=\"描述图像的替代文本\" data-v-4002a9dc></picture></div><div class=\"common-wrap\" data-v-4002a9dc><picture data-v-4002a9dc><source srcset=\"\n              https://static.knowledge.xag.cn/img/jijia2026/part2-1113.png?imageMogr2/format/webp\n            \" type=\"image/webp\" data-v-4002a9dc><source srcset=\"https://static.knowledge.xag.cn/img/jijia2026/part2-1113.png\" type=\"image/png\" data-v-4002a9dc><img src=\"https://static.knowledge.xag.cn/img/jijia2026/part2-1113.png\" alt=\"描述图像的替代文本\" data-v-4002a9dc></picture></div><div class=\"common-wrap\" data-v-4002a9dc><picture data-v-4002a9dc><source srcset=\"\n              https://static.knowledge.xag.cn/img/jijia2024/part3-1212.png?imageMogr2/format/webp\n            \" type=\"image/webp\" data-v-4002a9dc><source srcset=\"https://static.knowledge.xag.cn/img/jijia2024/part3-1212.png\" type=\"image/png\" data-v-4002a9dc><img src=\"https://static.knowledge.xag.cn/img/jijia2024/part3-1212.png\" alt=\"描述图像的替代文本\" data-v-4002a9dc></picture></div></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

import { onMounted, ref, computed, nextTick } from 'vue'
import { usePhoneDomAdaption } from '@/compositions/common'

type TableDataObj = Record<
  string,
  {
    amount: number[]
    price: number[]
  }
>


export default /*#__PURE__*/_defineComponent({
  __name: 'jijia-introduce-content',
  setup(__props) {

const { phoneDomEmAdaption } = usePhoneDomAdaption()

const baseHead = ['P100 Pro', 'V50 pro', 'P100', 'V50', 'V40', 'P80', 'P40', 'P20', 'P30', 'XP']
const advanceHead = ['P100 Pro', 'V50 Pro', 'P100', 'V50']

const baseObj: TableDataObj = {
  '1': {
    amount: [18000, 14000, 18000, 14000, 10000, 10000, 10000, 9000, 9000, 9000],
    price: [2000, 1800, 2000, 1800, 1600, 1700, 1600, 1600, 1600, 1600],
  },
  '2': {
    amount: [14000, 11000, 14000, 11000, 8000, 8000, 8000, 7000, 7000, 7000],
    price: [2100, 1900, 2100, 1900, 1700, 1800, 1700, 1700, 1700, 1700],
  },
  '3': {
    amount: [11000, 9000, 11000, 9000, 8000, 8000, 8000, 7000, 7000, 7000],
    price: [2200, 2000, 2200, 2000, 1800, 1900, 1800, 1800, 1800, 1800],
  },
}
const baseObjSecond: TableDataObj = {
  '1': {
    amount: [12000, 10000, 12000, 10000, 7000, 7000, 7000, 6000, 6000, 6000],
    price: [2600, 2400, 2600, 2400, 2100, 2100, 2100, 1800, 1800, 1800],
  },
  '2': {
    amount: [11000, 9000, 11000, 9000, 6000, 6000, 6000, 5000, 5000, 5000],
    price: [2800, 2600, 2800, 2600, 2100, 2100, 2100, 1750, 1750, 1750],
  },
}
const advanceObj: TableDataObj = {
  '1': {
    amount: [32000, 28000, 32000, 28000],
    price: [3800, 3300, 3800, 3300],
  },
  '2': {
    amount: [30000, 25000, 30000, 25000],
    price: [4000, 3600, 4000, 3600],
  },
  '3': {
    amount: [26000, 20000, 26000, 20000],
    price: [4300, 3800, 4300, 3800],
  },
}
const advanceObjSecond: TableDataObj = {
  '1': {
    amount: [24000, 20000, 24000, 20000],
    price: [5800, 5600, 5800, 5600],
  },
  '2': {
    amount: [20000, 16000, 20000, 16000],
    price: [6000, 5800, 6000, 5800],
  },
}
const baseActive = ref('1')
const baseActiveSecond = ref('1')
const advanceActive = ref('1')
const advanceActiveSecond = ref('1')
const baseTableStyle = computed(() => {
  // 68  84
  const ratio = window.innerWidth / 375
  const width = 68 * ratio + 84 * ratio * baseHead.length
  return `width: ${width}px`
})
const advanceTableStyle = computed(() => {
  // 68  84
  const ratio = window.innerWidth / 375
  const width = 68 * ratio + 84 * ratio * advanceHead.length
  return `width: ${width}px`
})

function changeBaseActive(value: string) {
  baseActive.value = value
}
function changeBaseActiveSecond(value: string) {
  baseActiveSecond.value = value
}
function changeAdvanceActiveSecond(value: string) {
  advanceActiveSecond.value = value
}

onMounted(() => {
  nextTick(() => {
    phoneDomEmAdaption(document.getElementById('content-main-wrap'))
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})